import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface AnimatedIconProps {
  icon: LucideIcon;
  className?: string;
  animation?: "float" | "pulse" | "glow" | "none";
  size?: number;
}

export const AnimatedIcon = ({ 
  icon: Icon, 
  className, 
  animation = "none",
  size = 20 
}: AnimatedIconProps) => {
  const animationClass = {
    float: "animate-float",
    pulse: "animate-pulse-slow",
    glow: "animate-glow",
    none: ""
  }[animation];

  return (
    <div className={cn("inline-flex", animationClass)}>
      <Icon className={className} size={size} />
    </div>
  );
};
